// 案件头部组件国际化配置 - 简体中文
export default {
  // 元信息标签
  creator: "创建人",
  createTime: "创建时间",
  updateTime: "更新时间",

  // 按钮和操作
  addressMonitor: "地址监控",
  edit: "编辑",
  delete: "删除",

  // 余额看板
  balanceBoard: {
    title: "余额看板-总资产余额",
    tooltipTitle: "可在画布中选择地址后右键加入余额看板",
    tooltipContent:
      "地址总资产余额是将根据本系统已收录的币种价值，按照地址所持有的所有主币和代币折算成USDT得出的总余额，币种价值受多种因素影响变化，总资产数据仅供参考。系统当前已支持",
    supportedCurrencies: "317个币种",
    detail: "详情 >",
    loadingText: "拼命加载中",
  },

  // 错误提示
  errors: {
    loadAssetFailed: "加载资产数据失败,请稍后重试",
    caseIdMissing: "caseInfo.id 不存在,无法获取资产详情",
  },
};
